import React, { useState } from 'react';

import { useHistory } from 'react-router';
import { makeStyles } from '@material-ui/core/styles';
import { Badge, Grid, Typography } from '@material-ui/core';
import MerchantLogo from '../assets/images/merchant-logo.svg';
import { useAuth } from '../hooks/useAuth';
import { config } from '../configs/config';
import NavDrawer from './Navigation/NavDrawer';
import MenuIcon from '@material-ui/icons/Menu';
import CancelIcon from '@material-ui/icons/Cancel';
import { ROUTES } from '../constants/route';
import { getIssuer } from '../services/pda';
import { red } from '@material-ui/core/colors';

const useStyles = makeStyles((theme) => ({
  container: {
    position: 'fixed',
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    padding: '12px 21px',
    boxSizing: 'border-box',
    justifyItems: 'center',
    placeItems: 'center',
    backgroundColor: theme.palette.background.paper,
    width: '100%',
    zIndex: 1,

    [theme.breakpoints.down('sm')]: {
      padding: '2px 3px',
      '&.auth': {
        gridTemplateColumns: '0.8fr 0.2fr',
      },
    },
  },
  gridLeft: {
    gridColumn: 1,
    justifySelf: 'left',
    minWidth: '195px',
  },
  gridCenter: {
    gridColumn: 2,
    minWidth: '195px',
  },
  dataPassportLogo: {
    height: '86px',
    width: '288px',

    [theme.breakpoints.down('md')]: {
      width: '288px',
    },

    [theme.breakpoints.down('sm')]: {
      height: '96px',
      width: '288px',
    },
  },
  merchantLogo: {
    height: '32px',
    width: '223px',

    [theme.breakpoints.up('sm')]: {
      height: '42px',
      width: '290px',
    },

    [theme.breakpoints.up('md')]: {
      height: '64px',
      width: '445px',
    },
  },
  signOutButton: {
    color: theme.palette.text.primary,
    backgroundColor: 'transparent',
    padding: 0,
    minWidth: 'auto',
    alignSelf: 'end',
    justifySelf: 'right',
    gridColumn: 2,
    maxHeight: '24px',
    minHeight: '24px',

    [theme.breakpoints.up('sm')]: {
      maxHeight: '32px',
      minHeight: '32px',
    },

    [theme.breakpoints.up('md')]: {
      gridColumn: 3,
      maxHeight: '40px',
      minHeight: '40px',
    },

    '&.merchant': {
      maxHeight: '32px',
      minHeight: '32px',

      [theme.breakpoints.up('sm')]: {
        maxHeight: '42px',
        minHeight: '42px',
      },

      [theme.breakpoints.up('md')]: {
        gridColumn: 3,
        maxHeight: '64px',
        minHeight: '64px',
      },
    },
  },
  menuButton: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));

type PropsType = {
  merchant?: boolean;
};

const DataPassportLogoHeader: React.FC<PropsType> = ({ merchant }) => {
  const classes = useStyles();
  const history = useHistory();
  const { logout, isAuthenticated, token } = useAuth();
  const [drawerOpen, setDrawerOpen] = useState(false);

  const onPassesClick = () => {
    setDrawerOpen(false);
    history.push(ROUTES.MERCHANT_DATA_PASS);
  };

  const onPerksClick = () => {
    setDrawerOpen(false);
    history.push(ROUTES.MERCHANT_OFFERS_LIST);
  };

  const onNewPerk = () => {
    setDrawerOpen(false);
    history.push(merchant ? '/offers/create' : '/');
  };

  const onProfileClick = () => {
    setDrawerOpen(false);
    history.push(!merchant ? '/profile' : '/');
  };

  const onProgressClick = () => {
    setDrawerOpen(false);
    history.push(!merchant ? '/progress' : '/');
  };

  const onPaymentsClick = () => {
    setDrawerOpen(false);
    history.push(merchant ? '/payments' : '/');
  };

  const onQRCodeClick = () => {
    setDrawerOpen(false);
    history.push('/qr');
  }

  const onCustomerSignupClick = () => {
    setDrawerOpen(false);
    history.push(ROUTES.MERCHANT_CUSTOMER_SIGNUP);
  }

  return (
    <>
      {isAuthenticated ?
        <Grid
          container
        spacing={4}
        alignItems="center"
        justifyContent="center"
        >
          <Grid item xs={12} style={{textAlign: 'center', marginTop: '5px'}}>
            {merchant ? (
              <a href={`${window.location.origin}/merchant`}>
                <img
                  src={MerchantLogo}
                  alt="Merchant Data Terminal"
                  className={classes.merchantLogo}
                />
              </a>
            ) : (
              <>
                <a href={window.location.origin}>
                  <img
                    src={config.logoUrl}
                    alt="Data Passport Logo"
                    className={classes.dataPassportLogo}
                  />
                </a>
              </>
            )}
            <div style={{float: 'right', margin: '5px'}}>
            {isAuthenticated && (
              <div onClick={() => setDrawerOpen(!drawerOpen)}>
                {drawerOpen ? <CancelIcon fontSize="large" style={{ color: red[500] }} /> : <Badge anchorOrigin={{ vertical: 'top', horizontal: 'left' }} color="secondary" badgeContent=" " variant="dot"><MenuIcon aria-label="menu" fontSize="large" color="primary" /></Badge>}
              </div>
            )}
            </div>
          </Grid>
          {!merchant && isAuthenticated && <Grid item xs={12} style={{ textAlign: 'center' }}>
            <Typography color="textPrimary" variant="h6">
              Universal ID: {getIssuer(token)}
            </Typography>
          </Grid>
          }
        </Grid>
      :
      <Grid container>
        <Grid item xs={12} style={{ textAlign: 'center' }}>
          {merchant ? (
            <a href={`${window.location.origin}/merchant`}>
              <img
                src={MerchantLogo}
                alt="Merchant Data Terminal"
                className={classes.merchantLogo}
              />
            </a>
          ) : (
            <>
              <a href={window.location.origin}>
                <img
                  src={config.logoUrl}
                  alt="Data Passport Logo"
                  className={classes.dataPassportLogo}
                />
              </a>
            </>
          )}
        </Grid>
      </Grid>
      }
      {
        drawerOpen && (
          <NavDrawer
            signOut={logout}
            onDataPasses={onPassesClick}
            onPerks={onPerksClick}
            onNewPerk={onNewPerk}
            onProfileClick={onProfileClick}
            onProgressClick={onProgressClick}
            onPaymentsClick={onPaymentsClick}
            onQRCodeClick={onQRCodeClick}
            onCustomerSignupClick={onCustomerSignupClick}
            isMerchant={merchant}
          />
        )
      }
    </>
  );
};

export default DataPassportLogoHeader;
